import React from 'react';
import LogoUmo from '../c-logosvg/umo-footer';

const EntryUmo = (props) => {
  const { Description } = props;
  return (
    <a href={props.Href} className="c-intro-content__item c-umo">
      <div className="c-intro-content__item__container">
        <div className="c-entry-lang__content-container">
          <div className="c-entry-lang__content-valign">
            <div className="c-entry-lang__content">
              <div className="c-entry-lang__logo">
                <LogoUmo link={false} />
              </div>
              {Description && (
                <h3 className="c-entry-lang__heading">{Description}</h3>
              )}
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

export default EntryUmo;
